import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { GET_CREATOR_COMPETITIONS } from "MVVM/GraphQL/competitions";
import { ICompetition } from "../../Competitions/@types";
import { getCompetitionPhase } from "../../Competitions/utils";

const POOL_SIZE = 10;
const MAX_OTHERS = 3;

export const CompetitionsBannerViewModel = () => {
  const { data, loading } = useQuery(GET_CREATOR_COMPETITIONS, {
    variables: {
      sort: "ENDING_SOONEST",
      first: POOL_SIZE,
    },
    fetchPolicy: "cache-and-network",
  });

  const { featured, others } = useMemo(() => {
    const all = (data?.creatorCompetitions?.nodes ?? []) as ICompetition[];

    const active = all.filter((c) => getCompetitionPhase(c) === "active");
    const upcoming = all
      .filter((c) => getCompetitionPhase(c) === "upcoming")
      .sort(
        (a, b) =>
          new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime(),
      );

    const featured =
      active.find((c) => c.sponsored) ??
      upcoming.find((c) => c.sponsored) ??
      null;

    const others = [...active, ...upcoming]
      .filter((c) => c._id !== featured?._id)
      .slice(0, MAX_OTHERS);

    return { featured, others };
  }, [data]);

  return { featured, others, loading };
};
